import { createReducer, on } from '@ngrx/store';
import { addNewAccountStoreDataType } from '../../core/models/Interfaces/addNewAccount';
import {
  addNewAccountFailed,
  addNewAccountReceived,
  addNewAccountRequest,
  resetNewAccountState,
} from '../actions/addNewAccount';

const initialState: addNewAccountStoreDataType = {
  isAccountAddedSuccessfully: false,
  isAccountAddedFailed: false,
  isSubmittingNewRecord: false,
};

export const addNewAccountReducer = createReducer(
  initialState,
  on(addNewAccountRequest, (state) => {
    return { ...state, isSubmittingNewRecord: true };
  }),
  on(addNewAccountReceived, (state, { data }: any) => {
    return {
      ...state,
      isSubmittingNewRecord: false,
      isAccountAddedSuccessfully: true,
      isAccountAddedFailed: false,
    };
  }),
  on(addNewAccountFailed, (state) => {
    return {
      ...state,
      isSubmittingNewRecord: false,
      isAccountAddedFailed: true,
      isAccountAddedSuccessfully: false,
    };
  }),
  on(resetNewAccountState, (state) => {
    return {
      ...state,
      isSubmittingNewRecord: false,
      isAccountAddedFailed: false,
      isAccountAddedSuccessfully: false,
    };
  }),
);
